import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=d74a6250&scoped=true&lang=pug&"
import script from "./tag.vue?vue&type=script&lang=js&"
export * from "./tag.vue?vue&type=script&lang=js&"
import style0 from "./tag.vue?vue&type=style&index=0&id=d74a6250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74a6250",
  null
  
)

export default component.exports